import { Amplify } from 'aws-amplify';
import { getGraphQLHeaders } from '@/core/graphql/utils/headers.util';

const endpoint = import.meta.env.VITE_APPSYNC_ENDPOINT as string;
const region = (import.meta.env.VITE_APPSYNC_REGION as string) ?? 'us-east-1';

/**
 * Configura Amplify con la API GraphQL de AppSync existente.
 * La autenticación se proporciona mediante headers personalizados usando el token de sesión (Cognito User Pools).
 */
export function configureAmplify(): void {
  Amplify.configure(
    {
      API: {
        GraphQL: {
          endpoint,
          region,
          defaultAuthMode: 'none',
        },
      },
    },
    {
      API: {
        GraphQL: {
          headers: async () => await getGraphQLHeaders(),
        },
      },
    }
  );
}
